import { Code, Flex, Stack } from '@chakra-ui/react';

import { MerchantOnboardingStatus } from '__generated__/GQL';
import Button from 'components/_core/Button';
import { Copyable } from 'components/_core/Copyable';
import Text from 'components/_core/Text';
import Loader from 'components/Loader';
import * as Layout from 'layouts/ContentLayout';

import { EmptyState } from './components/EmptyState';
import { MerchantDahsboard } from './components/MerchantDashboard';
import { MerchantOnboarding } from './components/MerchantOnboarding';
import { useDeleteMerchantSandboxAccountMutation } from './hooks/useDeleteMerchantSandboxAccountMutation';
import { useMerchantPageQuery } from './hooks/useMerchantPageQuery';
import locales from './locales';

export const Merchant = () => {
  const {
    error: queryError,
    loading: queryLoading,
    merchantAccount,
    refetch,
  } = useMerchantPageQuery();
  const [
    deleteMerchantAccount,
    { error: deleteAccountError, loading: deleteAccountLoading },
  ] = useDeleteMerchantSandboxAccountMutation();

  if (queryLoading) {
    return <Loader />;
  }

  const error = queryError || deleteAccountError;

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.Header
          action={
            merchantAccount ? (
              <Button
                isLoading={deleteAccountLoading}
                onClick={() =>
                  deleteMerchantAccount({
                    merchantAccountId: merchantAccount.merchantAccountId,
                  })
                }
                variant="danger"
              >
                {locales.deleteAccount}
              </Button>
            ) : null
          }
          title="Payment Service Provider"
        />

        <Stack gap="space-16">
          {merchantAccount?.providerAccountId ? (
            <Flex alignItems="baseline" gap="space-4">
              <Text>stripeAccountId</Text>

              <Copyable
                text={merchantAccount.providerAccountId}
                withHint={true}
              >
                <Code>{merchantAccount.providerAccountId}</Code>
              </Copyable>
            </Flex>
          ) : null}

          {!merchantAccount ? (
            <EmptyState />
          ) : (
            <>
              {merchantAccount.onboardingStatus ===
              MerchantOnboardingStatus.Incomplete ? (
                <MerchantOnboarding
                  onExit={() => {
                    refetch();
                  }}
                />
              ) : (
                <MerchantDahsboard merchantAccount={merchantAccount} />
              )}
            </>
          )}

          {error ? <Text variant="danger">{error.message}</Text> : null}
        </Stack>
      </Layout.Body>
    </Layout.Root>
  );
};
